// extracted by mini-css-extract-plugin
export default {"accountsPayableTable":"MWLVYq6tjFjyOTJsXEXV"};